import { useCreate } from '@refinedev/core';
import { Calendar, CalendarPlatform } from 'src/meetings/models';

type CreateCalendarInput = {
  authCode: string;
  state: string;
  platform: CalendarPlatform;
};

export const useCreateCalendarMutation = () => {
  const { mutateAsync, error, isLoading } = useCreate<Calendar>({
    resource: 'calendars',
  });

  const createCalendar = async (input: CreateCalendarInput): Promise<Calendar> => {
    const response = await mutateAsync({
      values: input,
    });
    return response.data;
  };

  return {
    createCalendar,
    isLoading,
    error,
  };
};
